import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seo/head";
import YonkersDeck from "@/pages/decks/YonkersDeck";
import AuthGate from "@/components/AuthGate";

export const Route = createFileRoute("/decks/yonkers")({
  head: () => seoHead("/decks/yonkers"),
  component: () => (
    <AuthGate><YonkersDeck /></AuthGate>
  ),
});
